
<header class="global-header">
  <div class="header-inner">
    <div class="header-row">
      <div class="header-left">
        <img src="/assets/Panasonic_logo.svg" alt="Logo" class="brand-logo">
        <span class="brand-text">Visual Studio</span>
        <a [href]="pvfTopUrl" class="nav-link-button top-link">
          <svg class="chevron-left" viewBox="0 0 36 36" width="18" height="18" aria-hidden="true">
            <path fill-rule="evenodd" d="M12,18v0a1.988,1.988,0,0,0,.585,1.409l7.983,7.98a2,2,0,1,0,2.871-2.772l-.049-.049L16.819,18l6.572-6.57a2,2,0,0,0-2.773-2.87l-.049.049-7.983,7.98A1.988,1.988,0,0,0,12,18Z"/>
          </svg>
          <span>Top</span>
        </a>
      </div>

      <div class="auth-section">
        <button *ngIf="(isAuthenticated$ | async)" class="nav-link-button" (click)="onLogout()">
          Logout
        </button>
      </div>
    </div>
  </div>
</header>

<div class="app-container">
  <router-outlet></router-outlet>
</div>

<footer>
  <p>Copyright © Panasonic Corporation</p>
  <div class="footer-links">
    <button type="button" class="nav-link-button" (click)="isAboutModalOpen = true">What is Panasonic Visual Studio?</button>
    <button type="button" class="nav-link-button" (click)="isContactModalOpen = true">Contact for Inquiry</button>
  </div>
</footer>

<app-info-modal
  [isOpen]="isAboutModalOpen"
  title="What is Panasonic Visual Studio?"
  (closed)="isAboutModalOpen = false">
  This platform offers functions to search for and create brand-compliant images and videos, along with AI-powered tools developed with copyright in mind, to support efficient creative work.<br>
  Take advantage of our image search and content generation features to boost productivity and maximize your creativity.
</app-info-modal>

<app-info-modal
  [isOpen]="isContactModalOpen"
  title="Contact for Inquiry"
  (closed)="isContactModalOpen = false">
  For any questions or issues, please contact us at the following email address:<br>
  <a href="mailto:pvs@ml.jp.panasonic.com">pvs&#64;ml.jp.panasonic.com</a>
</app-info-modal>
